import { render, staticRenderFns } from "./attr-editor.vue?vue&type=template&id=14b27bb0&scoped=true"
import script from "./attr-editor.vue?vue&type=script&lang=js"
export * from "./attr-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b27bb0",
  null
  
)

export default component.exports